export default function Stats() {
  const stats = [
    {
      value: '100',
      label: 'Chrome Products',
      suffix: '%',
      icon: 'ri-copper-diamond-line'
    },
    {
      value: '100',
      label: 'Logistics',
      suffix: '%',
      icon: 'ri-truck-line'
    },
    {
      value: '100',
      label: 'Processing',
      suffix: '%',
      icon: 'ri-settings-3-line'
    },
    {
      value: '100',
      label: 'Consultation',
      suffix: '%',
      icon: 'ri-lightbulb-line'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-[#8B1538] to-red-900 text-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 font-['Montserrat']">
            Our Commitment
          </h2>
          <p className="text-lg text-red-100 max-w-3xl mx-auto">
            100% dedication to excellence across all our service areas
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="text-center bg-white/10 backdrop-blur-sm p-8 rounded-lg hover:bg-white/20 transition-all duration-300"
            >
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${stat.icon} text-3xl text-white`}></i>
              </div>
              <div className="text-5xl md:text-6xl font-bold mb-2 font-['Montserrat']">
                {stat.value}
                <span className="text-3xl">{stat.suffix}</span>
              </div>
              <div className="text-lg text-red-100 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-xl text-red-100 max-w-4xl mx-auto leading-relaxed">
            Chrome is ever in demand, making it hard to idle on the floor. Our commitment to quality, reliability, and timely delivery ensures that we remain the preferred partner for chrome commodity trading and processing.
          </p>
        </div>
      </div>
    </section>
  );
}
